import { DrawerProps, useDrawer } from '@cast/design-system';

import { EdgeConfigurationDrawer } from './EdgeConfigurationDrawer';
import { EdgeConfigurationListItem } from '../../types';

export const useEdgeConfigurationDrawer = () => {
  const { open } = useDrawer();

  return {
    openEdgeConfigurationDrawer: (props?: {
      edgeConfiguration: EdgeConfigurationListItem;
      drawerProps?: DrawerProps;
    }) =>
      open({
        component: EdgeConfigurationDrawer,
        props: {
          edgeConfiguration: props?.edgeConfiguration,
          ...props?.drawerProps,
        },
      }),
  };
};
